<template>
  <div class="p-feed">
    <CommonHead :pageSource="'feeds'"></CommonHead>

    <main class="feed-main">
      <JoLoadMore
        ref="loadmore"
        @onRefresh="onRefresh"
        @onLoadMore="onLoadMore"
        :class="{ emptyLoad: isEmptyFeeds }"
      >
        <!-- 热门动态顶部 banner 广告位 -->
        <BannerAd v-if="feedType === 'hot'" type="feed:hot" />
        <ul v-gif-play class="feed-list">
          <li
            v-for="(feed, index) in pinned"
            :key="`pinned-feed-${feedType}-${feed.id}-${index}`"
            :data-feed-id="feed.id"
          >
            <template v-if="feed.id">
              <FeedCard :feed="feed" :pinned="true" />
            </template>
          </li>
          <li
            v-for="(card, index) in feeds"
            :key="`feed-${feedType}-${card.id}-${index}`"
            :data-feed-id="card.id"
          >
            <FeedCard v-if="card.user_id" :feed="card" />
            <FeedAdCard v-if="card.space_id" :ad="card" />
          </li>
        </ul>
      </JoLoadMore>
    </main>
    <!-- <FootGuide /> -->
    <div
      class="create-question"
      @click="$router.push({ path: '/post/pic' })"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { limit } from "@/api";
import FeedCard from "@/components/FeedCard/FeedCard.vue";
import FeedAdCard from "./components/FeedAdCard.vue";
import BannerAd from "@/components/advertisement/BannerAd.vue";
import CommonHead from "../home/common-head.vue";

const feedTypesMap = ["new", "hot", "follow"];

export default {
  name: "FeedList",
  components: { FeedCard, BannerAd, FeedAdCard, CommonHead },
  computed: {
    ...mapGetters("feed", ["hot", "new", "follow", "pinned"]),
    feeds() {
      return this[this.feedType];
    },
    feedType: {
      get() {
        return this.$route.query.type || "hot";
      },
      set(val) {
        const { query } = this.$route;
        this.$router.replace({ query: { ...query, type: val } });
      },
    },
    after() {
      const len = this.feeds.length;
      if (!len) return 0;
      if (this.feedType !== "hot") return this.feeds[len - 1].id; // after
      return this.feeds[len - 1].hot; // offset
    },
    isEmptyFeeds() {
      return this.pinned.length === 0 && this.feeds.length === 0;
    },
  },
  watch: {
    feedType(val) {
      if (feedTypesMap.includes(val)) {
        this.$refs.loadmore.beforeRefresh();
      }
    },
  },
  created() {
    this.$store.dispatch("feed/getAdvertise");
  },
  activated() {
    if (this.$route.query.refresh) {
      this.$refs.loadmore.beforeRefresh();
    }
  },
  methods: {
    async onRefresh() {
      const type = this.feedType.replace(/^\S/, (s) => s.toUpperCase());
      const action = `feed/get${type}Feeds`;
      let data;
      try {
        data = await this.$store.dispatch(action, { refresh: true });
        this.$refs.loadmore.afterRefresh(data.length < limit);
      } catch (error) {
        this.$refs.loadmore.afterRefresh();
      }
    },
    async onLoadMore() {
      const type = this.feedType.replace(/^\S/, (s) => s.toUpperCase());
      const action = `feed/get${type}Feeds`;
      const data = await this.$store.dispatch(action, { after: this.after });
      this.$refs.loadmore.afterLoadMore(data.length < limit);
    },
  },
};
</script>

<style lang="less" scoped>
.p-feed {
  .feed-list > li + li {
    margin-top: 20px;
  }
  ::v-deep .jo-loadmore-head-box {
    transform: translateY(0px) !important;
  }
  ::v-deep .emptyLoad {
    .jo-loadmore-head-box {
      display: none;
    }
  }
  .create-question {
    width: 44 * 2px;
    height: 44 * 2px;
    position: fixed;
    bottom: 50 * 2px;
    right: 18 * 2px;
    background-image: url("~@/images/home-icon-plus.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50%;
  }
}
</style>
